
import Helper from "../../../shared/modules/Helper";
import PaperPlaneIcon from "./Icons/PaperPlaneIcon";
import PropTypes from "prop-types";
import React from "react";
const ProductPreview = ({productDescriptor}) => (
  <div className="product-preview mt16">
    <div className="product color-coral-3-bg">
      <div className="product-image">
        <img
          alt="product"
          src={productDescriptor.photo}
        />
      </div>
      <div className="product-information">
        <div className="bold">
          {productDescriptor.designer_name}
        </div>
        <h4 className="styled_h4">
          {productDescriptor.name}
        </h4>
        <div>
          {`retail price $${Helper.formatPriceCents(productDescriptor.retail_price)}`}
        </div>
        <div className="tax-disclaimer color-dark-grey ">
          Sales tax applied at checkout
        </div>
      </div>
    </div>
    <div className="delivery-mobile color-coral-2-bg">
      <span>
        <PaperPlaneIcon />
      </span>
      <span className="bold">
        ships in 1-2 business days
      </span>
    </div>
  </div>
);

export default ProductPreview;

ProductPreview.propTypes = {"productDescriptor": PropTypes.object.isRequired};
